import { Component, WritableSignal, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IqRulesStateService } from '../state';

@Component({
    selector: 'iq-rules-register',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-rules-register.component.html',
    styleUrl: './iq-rules-register.component.scss',
})
export class IqRulesRegisterComponent {
    loaded: WritableSignal<boolean> = signal(false);
    rules: IqRulesStateService = inject(IqRulesStateService);
    constructor() {
        setTimeout(() => {
            this.loaded.set(true);
        });
    }
}
